import React, { Component } from 'react';
import ConvertAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/ConvertAppIcon';
import BetaListDialog from '../Dialogs/BetaListDialog.jsx';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';

const ConvertStrategy = {
  previewInfo: {
    name: 'Convert',
    iconSvg: <ConvertAppIcon size={'xlarge'} />,
  },
  headerInfo: {
    name: 'Convert',
    category: 'Website design',
    details:
      'Convert sites are the easiest way to improve your SEO and win more website sales. We constantly monitor your sites performance and make continual improvements, so you can focus on running your business. We even include website updates for free!',
    iconSvg: <ConvertAppIcon size={'xlarge'} />,
  },
  sellingPoints: {
    headline: 'Why convert websites pay for themselves',
    bottomDescription:
      'Convert Websites come with Housecall Pro Online Booking integrated (if enabled) and the NiceJob reputation platform fully integrated. Setting up your new Convert website takes as little as 15 minutes of your time, and we’ll design, build, and launch your new site within 14 days.',
    unorderedPoints: [
      'Most service industry websites win 2-4 leads for every 100 website visitors',
      'Convert websites on average win 6 - 10 leads for every 100 website visitors',
      'So if for example the lifetime value of one customer is $1000, then upgrading to a Convert website can earn you several thousand dollars per month',
    ],
  },
  price: {
    price: '',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={6}>
          <Typography align="left" variant="body1" color="textSecondary">
            Standard + Convert
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            $175/mo + $399
          </Typography>
          <Grid item xs={12}>
            <Typography align="right" variant="body1">
              one time setup
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    ),
    hideToggle: true,
    showBetaButton: true,
  },
  supportContacts: [
    { type: 'Email', contact: 'hello@nicejob.com' },
    { type: 'Phone', contact: '888-336-9082' },
  ],
  dialog: <BetaListDialog />,
};

export default ConvertStrategy;
